import { render, staticRenderFns } from "./ContenedorComponent.vue?vue&type=template&id=276ef2d4&"
import script from "./ContenedorComponent.vue?vue&type=script&lang=js&"
export * from "./ContenedorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports